/**
 * Main Presentation for Home Page
 */

import { CoverImage, Profile, Verified } from "@/assets";
import {
  NavBlock,
  Content,
  FacebookMobileContainer,
  ProfileContent,
  ProfileCoverImage,
  ProfileCoverImageContainer,
  ProfileImage,
  ProfileImageContainer,
  ProfileName,
  ProfileTopCover,
  FollowingContainer,
  FollowingContent,
  Dot,
  NavButtonCaption,
  PageSubContent,
  FollowButton,
} from "../styling/homePage.styles";
import { Outlet } from "react-router-dom";
import Navbar from "@/features/static/navbar/Navbar";

const HomePagePresentation = () => {
  return (
    <FacebookMobileContainer>
      <ProfileImageContainer>
        <ProfileCoverImageContainer>
          <ProfileCoverImage src={CoverImage} alt="Cover Image" />
          <ProfileImage src={Profile} alt="Profile" />
        </ProfileCoverImageContainer>
      </ProfileImageContainer>
      <ProfileContent>
        <ProfileName>
          Owen Burns <img src={Verified} />
        </ProfileName>
        <Content fontSize="16px" margin="0px 0px 0px 25px">
          Turning thoughts into reality! 🖥️
        </Content>
        <Content
          style={{ fontWeight: "bold" }}
          fontSize="16px"
          margin="5px 0px 0px 25px"
        >
          QA Engineer
        </Content>

        <Content fontSize="16px" margin="25px 0px 0px 25px">
          Java | React | React Native | NodeJS | PHP |<br /> .NET | Python | SQL
        </Content>
        <FollowingContainer>
          <FollowingContent>97 Followers</FollowingContent>
          <Dot />
          <FollowingContent>83 Connections</FollowingContent>
        </FollowingContainer>

        <FollowButton>Follow</FollowButton>
      </ProfileContent>
      <NavBlock>
        <NavButtonCaption to={"feed"}>
          <span>Feed</span>
        </NavButtonCaption>
        <NavButtonCaption to={"about"}>
          <span>About</span>
        </NavButtonCaption>
        <NavButtonCaption to={"content"}>
          <span>Content</span>
        </NavButtonCaption>
        <NavButtonCaption to={"projects"}>
          <span>Projects</span>
        </NavButtonCaption>
      </NavBlock>
      <PageSubContent>
        <Outlet />
      </PageSubContent>
    </FacebookMobileContainer>
  );
};

export default HomePagePresentation;
